import { render } from "./Ions.vue?vue&type=template&id=0cb60972"
import script from "./Ions.vue?vue&type=script&lang=js"
export * from "./Ions.vue?vue&type=script&lang=js"
script.render = render

export default script